import { BusinessAttachmentService } from '@/services/BusinessAttachmentsService';
import { useEffect, useState } from 'react';

export function useAttachments(businessId?: number) {
  const [attachments, setAttachments] = useState<[]>([]);
  const [filePreview, setFilePreview] = useState<string | null>(null);

  useEffect(() => {
    getBusinessAttachments();
  }, [businessId]);

  // Função para buscar os anexos do negócio
  const getBusinessAttachments = async () => {
    if (!businessId) return;
    const response = await BusinessAttachmentService.getBusinessAttachments(businessId);
    if (response) {
      setAttachments(response);
      return response;
    }
  };

  // Função para deletar um anexo
  const deleteBusinessAttachments = async (id: number) => {
    const response = await BusinessAttachmentService.deleteBusinessAttachments(id);
    if (response) {
      return response;
    }
  };

  // Função para visualizar um arquivo
  const viewFile = async (id: number) => {
    try {
      const response = await BusinessAttachmentService.attachmentPreview(id);
      const file = response.data;
      const fileType = file.type;

      // Se o arquivo for uma imagem, exibe a imagem
      if (fileType.startsWith('image/')) {
        const fileURL = `10.86.254.128:3001/uploads/${file.path}`; // A URL da imagem
        setFilePreview(fileURL); // Atualiza a pré-visualização com a URL da imagem
      } else if (fileType === 'application/json' || fileType === 'application/sql') {
        // Para arquivos JSON ou SQL, exibe os primeiros 200 caracteres
        const text = await fetch(file.path).then((res) => res.text());
        setFilePreview(text.substring(0, 200)); // Exibe os primeiros 200 caracteres
      } else {
        setFilePreview(null); // Para outros tipos de arquivo, não mostra nada
      }
    } catch (error) {
      console.error('Erro ao buscar o arquivo:', error);
      setFilePreview(null); // Em caso de erro, não exibe nada
    }
  };

  return {
    attachments,
    getBusinessAttachments,
    deleteBusinessAttachments,
    viewFile, // Função exportada para visualização de arquivos
    filePreview // Exporte o estado da pré-visualização para ser usado no componente
  };
}
